/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PersonFeedbackAggregatedDto } from '../models/person-feedback-aggregated-dto';
import { PersonFeedbackDto } from '../models/person-feedback-dto';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getUserFeedback
   */
  static readonly GetUserFeedbackPath = '/contacts/{personId}/feedback';

  /**
   * Get user's feedback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserFeedback()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserFeedback$Response(params: {
    personId: string;
  }): Observable<StrictHttpResponse<PersonFeedbackDto>> {

    const rb = new RequestBuilder(this.rootUrl, FeedbackService.GetUserFeedbackPath, 'get');
    if (params) {
      rb.path('personId', params.personId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonFeedbackDto>;
      })
    );
  }

  /**
   * Get user's feedback.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUserFeedback$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserFeedback(params: {
    personId: string;
  }): Observable<PersonFeedbackDto> {

    return this.getUserFeedback$Response(params).pipe(
      map((r: StrictHttpResponse<PersonFeedbackDto>) => r.body as PersonFeedbackDto)
    );
  }

  /**
   * Path part for operation updateUserFeedback
   */
  static readonly UpdateUserFeedbackPath = '/contacts/{personId}/feedback';

  /**
   * Save user's feedback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserFeedback()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserFeedback$Response(params: {
    personId: string;
    body: PersonFeedbackDto
  }): Observable<StrictHttpResponse<PersonFeedbackDto>> {

    const rb = new RequestBuilder(this.rootUrl, FeedbackService.UpdateUserFeedbackPath, 'put');
    if (params) {
      rb.path('personId', params.personId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonFeedbackDto>;
      })
    );
  }

  /**
   * Save user's feedback.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateUserFeedback$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserFeedback(params: {
    personId: string;
    body: PersonFeedbackDto
  }): Observable<PersonFeedbackDto> {

    return this.updateUserFeedback$Response(params).pipe(
      map((r: StrictHttpResponse<PersonFeedbackDto>) => r.body as PersonFeedbackDto)
    );
  }

  /**
   * Path part for operation getFeedbackAggregated
   */
  static readonly GetFeedbackAggregatedPath = '/contacts/{personId}/feedback/aggregated';

  /**
   * Get feedback aggregated.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeedbackAggregated()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeedbackAggregated$Response(params: {
    personId: string;
  }): Observable<StrictHttpResponse<PersonFeedbackAggregatedDto>> {

    const rb = new RequestBuilder(this.rootUrl, FeedbackService.GetFeedbackAggregatedPath, 'get');
    if (params) {
      rb.path('personId', params.personId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonFeedbackAggregatedDto>;
      })
    );
  }

  /**
   * Get feedback aggregated.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFeedbackAggregated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeedbackAggregated(params: {
    personId: string;
  }): Observable<PersonFeedbackAggregatedDto> {

    return this.getFeedbackAggregated$Response(params).pipe(
      map((r: StrictHttpResponse<PersonFeedbackAggregatedDto>) => r.body as PersonFeedbackAggregatedDto)
    );
  }

}
